document.addEventListener("DOMContentLoaded", function() {
    const faqItems = document.querySelectorAll(".monohydrate-seventh__item");

    faqItems.forEach(item => {
        const btn = item.querySelector(".monohydrate-seventh__question");
        btn.addEventListener("click", () => {
            const isActive = item.classList.contains("active");

            faqItems.forEach(i => i.classList.remove("active"));

            if (!isActive) {
                item.classList.add("active");
            }
        });
    });
});